import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/shared/integrations/supabase/client";

export interface ProjectZoneOption {
  id: string;
  name: string;
}

/** Zones defined for a project, for the asset zone picker. */
export function useProjectZones(projectId: string | null) {
  return useQuery<ProjectZoneOption[]>({
    queryKey: ["project-zones", projectId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("project_zones")
        .select("id, name")
        .eq("organization_id", projectId!)
        .order("name", { ascending: true });
      if (error) throw error;
      return data ?? [];
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000,
  });
}
